import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SmartTireService } from 'src/app/services/feature/smartTire/smart-tire.service';

@Component({
  selector: 'app-smarttire-left',
  templateUrl: './smarttire-left.component.html',
  styleUrl: './smarttire-left.component.scss',
  standalone: false
})
export class SmarttireLeftComponent {
  currentComponent: any;
  isMobile: any;
  iconToggler: boolean = true;
  private destroy$ = new Subject<void>();
  constructor(private smartireService: SmartTireService, private cdr: ChangeDetectorRef, private BreakpointObserver: BreakpointObserver) {
    this.BreakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        this.isMobile = result.matches;

      });
  }
  SelectedComponent(componentName, event) {
    event.preventDefault();

    this.smartireService.valueDisclaimer$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      if (x) {
        this.smartireService.currentComponent$.next(componentName);
      } else {
        componentName = 'visitorInfo';
      }
    })

  }
  ngOnInit() {
    this.smartireService.currentComponent$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      if (x != null) {
        this.currentComponent = x;
      } else {
        this.currentComponent = 'visitorInfo';
      }
      this.cdr.detectChanges();
    })
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
